import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import classNames from 'classnames'
import slickStyles from '../../dist/external/slick.css' // eslint-disable-line no-unused-vars
import slickThemeStyles from '../../dist/external/slick-theme.css' // eslint-disable-line no-unused-vars

//	Ref: https://react-slick.neostack.com/docs/api

import Img from './Img'
import styles from './ImageCarousel.icss'

class ImageCarousel extends React.Component {
	static getDerivedStateFromProps(props, state) {
		return (props.images && props.images.length !== state.imageCount) ? { selectedItem: 0, imageCount: props.images && props.images.length } : {}
	}

	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		const { children, images, className, ...props } = this.props
		return (
			<Slider
				ref={(slider) => {
					if (this.props.getRef) {
						this.props.getRef(slider)
					}
				}}
				className={classNames(styles.imageCarousel, className)}
				dots={images && images.length > 1}
				arrows={images && images.length > 1}
				{...props}
				afterChange={(selectedItem) => {
					if (this.props.onChange) {
						this.props.onChange(selectedItem)
					}
				}}
			>
				{children && children}
				{!children && images && images.map((image, idx) => (
					// eslint-disable-next-line react/no-array-index-key
					<div key={`image_${idx}-${JSON.stringify(image)}`} className={styles.imageSurround}>
						<Img content={image} className={styles.image + (this.props.cover ? ` ${styles.imageCover}` : '')} />
					</div>
				))}
			</Slider>
		)
	}
}

ImageCarousel.propTypes = {
	getRef: PropTypes.func,
	children: PropTypes.node,
	className: PropTypes.string,
	images: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	showStatus: PropTypes.bool,
	showThumbs: PropTypes.bool,
	autoPlay: PropTypes.bool,
	infiniteLoop: PropTypes.bool,
	cover: PropTypes.bool,
	onChange: PropTypes.func
}

ImageCarousel.defaultProps = {
	getRef: undefined,
	children: undefined,
	className: undefined,
	showStatus: false,
	showThumbs: false,
	autoPlay: false,
	infiniteLoop: true,
	cover: false,
	onChange: undefined,
	images: undefined
}

export default ImageCarousel



// WEBPACK FOOTER //
// ./src/components/ImageCarousel.jsx